import React from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { InputPassword, Typography } from '@lyearn/ui';

import { PasswordWithTooltipProps } from './types';

const PasswordWithTooltipMobile = ({
  isError,
  errorMessage,
  onChangeText,
  placeholder,
  onBlur,
}: PasswordWithTooltipProps) => {
  const { t } = useTranslation();
  const [showPasswordInfo, { on, off }] = useToggle(false);

  return (
    <>
      <InputPassword
        fullWidth
        error={isError}
        margin="dense"
        placeholder={placeholder}
        size="large"
        onBlur={() => {
          off();
          onBlur?.();
        }}
        onChangeText={onChangeText}
        onFocus={on}
      />
      {errorMessage && isError ? (
        <Typography className="mt-8 ms-8" color="text-text-error" variant="body-short-03">
          {errorMessage}
        </Typography>
      ) : null}
      {showPasswordInfo ? (
        <Typography className="mt-8 ms-8" color="text-text-secondary" variant="body-short-02">
          {t('Auth:passwordStrength')}
        </Typography>
      ) : null}
    </>
  );
};

export default React.memo(PasswordWithTooltipMobile);
